import React from 'react';
import { InsuranceOrderingUploadTemplate } from 'themes/application/insurance-ordering/pages';
import { observer } from 'mobx-react';
import { InsuranceOrderingUploadViewStore } from 'application/insurance-ordering/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new InsuranceOrderingUploadViewStore(rootStore), 'insuranceOrderingUploadViewStore')
@observer
class InsuranceOrderingUpload extends React.Component {
    render() {
        return <InsuranceOrderingUploadTemplate {...this.props} />
    }
}

export default InsuranceOrderingUpload;